























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { GripItem } from '@/interfaces/grip-item.interface'
import { APIWidget } from '../../models/api/widget.model'
// import CirclesPercentage from '@/components/widgets/CirclesPercentage.vue'
import DataTable from '@/components/widgets/DataTable.vue'
import PieChart from '@/components/widgets/PieChart.vue'
import LineVerticalChart from '@/components/widgets/LineVerticalChart.vue'
import RangeBarChart from '@/components/widgets/RangeBarChart.vue'
import { checkPermissions } from '@/directives/permissionDirective'

@Component({
    components: {
        DataTable,
        PieChart,
        LineVerticalChart,
        RangeBarChart
    }
})
export default class Dashboard extends Vue {
    loading = true
    defaultHeight = 8
    defaultCols = 6
    isMounted = false
    userLoaded = false
    metabaseDashboardUrl = process.env.VUE_APP_METABASE_DASHBOARD_URL || ''
    widgets: APIWidget[] = []
    layout: GripItem[] = []

    get mobileView () {
        return this.isMounted && ['xs', 'sm'].includes(this.$vuetify.breakpoint.name)
    }

    get userAuth () {
        return this.$store.state.AuthStore.auth?.user
    }

    get canViewMetabaseDashboard () {
        if (!this.userLoaded) return false
        return checkPermissions('externalDashboard.view')
    }

    get showMetabaseDashboard () {
        return this.canViewMetabaseDashboard && !!this.metabaseDashboardUrl
    }

    get layoutPreference () {
        const preference = localStorage.getItem('widgets')
        if (preference && this.userAuth) {
            const localPreference = JSON.parse(preference)
            if (localPreference.userId === this.userAuth.userId) {
                return localPreference
            }
        }
        return null
    }

    get resizable () {
        if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
            return false
        } else {
            return true
        }
    }

    get draggable () {
        if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
            return false
        } else {
            return true
        }
    }

    @Watch('mobileView')
    onMobileViewChange (value: boolean) {
        if (value) {
            this.setMobileview()
        } else {
            this.formatDataWidgets()
        }
    }

    setMobileview () {
        if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)) {
            this.layout = this.layout.map(x => {
                x.w = 12
                return x
            })
        }
    }

    changeChart (chart: {index: number; chart: string}) {
        this.layout.map(x => {
            if (x.i === chart.index) {
                x.component = chart.chart
            }
            return x
        })
    }

    itemLoading (loading: boolean, index: number) {
        this.layout.map(x => {
            if (x.i === index) {
                x.loading = loading
            }
            return x
        })
    }

    moveEvent (i: number) {
        this.itemLoading(true, i)
    }

    movedEvent (i: number) {
        this.itemLoading(false, i)
    }

    resizeEvent (i: number) {
        this.itemLoading(true, i)
    }

    resizedEvent (i: number) {
        this.itemLoading(false, i)
    }

    layoutUpdatedEvent (newLayout: GripItem[]) {
        this.layout = newLayout.map(x => {
            x.h = this.defaultHeight
            x.w = x.w < 4 ? 4 : x.w
            x.loading = false
            return x
        })
        this.$store.dispatch('savePreferences', this.layout)
    }

    setLayoutPreference () {
        const preference: GripItem[] = this.layoutPreference.layouts
        for (const value of this.widgets) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const item = preference.find(x => x.i === value.widgetId)
            if (item) {
                item.component = value.widgetDefaultWidgetChartId.widgetChartName
                item.title = value.widgetTitle
                item.data = value
                this.layout.push(item)
            }
        }
        this.setMobileview()
    }

    getWidgets () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getWidgets')
                .then(resp => {
                    if (resp?.status === 200) {
                        this.widgets = resp.data
                        if (this.layoutPreference) {
                            this.setLayoutPreference()
                        } else {
                            this.formatDataWidgets()
                        }
                        resolve()
                    }
                })
        })
    }

    formatDataWidgets () {
        this.layout = []
        let colsInUse = 0
        const maxWidth = 12
        let yCalc = 0
        for (const value of this.widgets) {
            let xCalc = 0
            let sumed = false
            if (colsInUse < maxWidth || (colsInUse + value.widgetDefaultWidth) <= maxWidth) {
                colsInUse = colsInUse + value.widgetDefaultWidth
                xCalc = colsInUse - value.widgetDefaultWidth
                sumed = true
            } else {
                colsInUse = 0
                xCalc = 0
            }
            if ((colsInUse + value.widgetDefaultWidth) <= maxWidth && !sumed) {
                colsInUse = colsInUse + value.widgetDefaultWidth
            }
            sumed = false
            const newItem: GripItem = {
                i: value.widgetId,
                x: xCalc,
                y: yCalc,
                w: value.widgetDefaultWidth,
                h: this.defaultHeight,
                title: value.widgetTitle,
                component: value.widgetDefaultWidgetChartId.widgetChartName,
                loading: true,
                data: value
            }
            this.layout.push(newItem)

            if (colsInUse === maxWidth) {
                yCalc = yCalc + this.defaultHeight
            }
        }
        this.setMobileview()
    }

    async mounted () {
        this.isMounted = true
        await this.$store.dispatch('getUserLogued')
        this.userLoaded = true
        // this.getWidgets()
        this.loading = false
        this.setMobileview()
    }
}
